export const VERTICALS = [
  "Fashion & Apparel",
  "Beauty & Personal Care",
  "Electronics & Gadgets",
  "Health & Wellness",
  "Home & Garden",
  "Food & Beverage",
  "Baby & Kids",
  "Pets",
  "Sports & Outdoors",
  "Art & Collectibles",
  "Automotive",
  "Digital Goods",
  "B2B / Wholesale",
  "Subscription Boxes",
  "Print-on-Demand / Dropshipping",
  "Jewelry & Accessories",
  "Luxury Goods",
  "Books & Media",
  "Music & Instruments",
  "Toys & Games",
  "Adult Products",
  "Party & Events",
  "Office Supplies",
  "Industrial & Scientific",
  "Cannabis & CBD",
  "Eco-Friendly & Sustainable",
  "Religious & Spiritual",
  "Gaming & Esports",
  "Education & Learning",
  "Hobbies & Crafts",
  "DIY & Tools",
  "Outdoor & Survival Gear",
  "Travel & Luggage",
  "Marketplace / Aggregator",
  "Ethnic & Cultural Goods",
  "Charity / Nonprofit",
] as const;

export const VERTICAL_OPTIONS = VERTICALS.map((vertical) => ({
  value: vertical,
  label: vertical,
}));
